import type { ToastState } from "@/hooks/useToast";

export default function Toast({ toast, onClose }: { toast: ToastState | null; onClose: () => void }) {
  if (!toast) return null;
  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[80] animate-fade-up">
      <button
        type="button"
        onClick={onClose}
        className="flex items-center gap-2 px-5 py-3 rounded-full bg-foreground-950 text-background-50 text-sm cursor-pointer"
      >
        <i
          className={toast.type === "success" ? "ri-checkbox-circle-fill text-primary-400" : "ri-information-fill text-primary-400"}
          aria-hidden="true"
        ></i>
        {toast.message}
      </button>
    </div>
  );
}